// eslint-disable-next-line check-file/filename-blocklist
import { LocalStorageKey } from 'core-framework/constant/StorageKeys';
import { getTodayDate } from 'core-framework/util/datetime/date';
import { addYears } from 'date-fns';
import { getItemFromLocalStorage, setItemInLocalStorage } from 'core-framework/window/storage';
import { LoyaltySearchType } from 'core/type/LoyaltySearch.types';

interface LoyaltySearchTypeLocalStorage {
    expires: Date;
    data: LoyaltySearchType;
}

export const setLoyaltySearchTypeToLocalStorage = (loyaltySearchType: LoyaltySearchType) => {
    if (loyaltySearchType === LoyaltySearchType.UNKNOWN) return;

    const todayDate = getTodayDate();
    const expiryDateOneYearFromToday = addYears(todayDate, 1);
    const data: LoyaltySearchTypeLocalStorage = {
        expires: expiryDateOneYearFromToday,
        data: loyaltySearchType,
    };
    const dataAsString = JSON.stringify(data);
    setItemInLocalStorage(LocalStorageKey.LOYALTY_SEARCH_TYPE_KEY, dataAsString);
};

export const getLoyaltySearchTypeFromLocalStorage = () => {
    const dataAsString = getItemFromLocalStorage(LocalStorageKey.LOYALTY_SEARCH_TYPE_KEY);

    if (dataAsString === null) return undefined;

    try {
        const dataAsJson: LoyaltySearchTypeLocalStorage = JSON.parse(dataAsString) as LoyaltySearchTypeLocalStorage;
        return dataAsJson.data;
    } catch (error) {
        return undefined;
    }
};
